import React from "react";
import "./Description.css"

const Description = () => {
  return (
    <section className="team-description">
      <div className="description-container">
        <h2 className="description-title">About Our Team</h2>
        <p className="description-text">
          The Gladiators Football Team, based in Bournemouth, is dedicated to achieving greatness on and off the field. 
          Established in 2022, our team has won multiple titles and continues to grow as a community-driven, performance-oriented football club.
        </p>
      </div>
    </section>
  );
};

export default Description;
